import { useState } from 'react';
import { v4 as uuid } from 'uuid';
import { Link, useNavigate } from 'react-router-dom';
import { ProfileOpeningModal } from 'admin/components/ProfileModals/profileOpeningModal';
import { useOutsideClick } from 'hooks/useOutsideClick';
import { ITAH_ADMIN_LISTS } from 'utils/constant';
import { Images } from 'assets/images';
import { ROUTES } from 'utils/routeNames';
import {
  LeftSideHeader,
  HeaderWrapper,
  ItahLogo,
  ListWrapper,
  MenuItems,
  HeaderList,
  HeaderTitleLists,
  HamburgerMenu,
  LogoAndHamburger,
  ListImage,
  AdminInfo,
  UserPicture,
  NameAndEmail,
  UserName,
  UserEmail,
  RightVector,
  SampleModalWrapper,
} from './styled';

export const LeftHeader = () => {
  const [isHeaderVisible, setIsHeaderVisible] = useState(false);
  const [isLaptopModal, setIsLaptopModal] = useState(false);
  const navigate = useNavigate();
  const { ref, isOpen, setIsOpen } = useOutsideClick();

  const toggleModal = () => {
    setIsOpen((prev) => !prev);
  };

  const toggleLaptopModal = () => {
    setIsLaptopModal((prev) => !prev);
  };

  const toggleBurgerMenu = () => {
    setIsHeaderVisible((prev) => !prev);
  };

  return (
    <LeftSideHeader>
      <HeaderWrapper>
        <LogoAndHamburger>
          <ItahLogo
            src={Images.whiteLogo}
            onClick={() => navigate(ROUTES.ADMIN_HOME)}
          />
          <HamburgerMenu src={Images.hamburgerIcon} onClick={toggleBurgerMenu} />
        </LogoAndHamburger>
        <ListWrapper burgerMenu={isHeaderVisible}>
          <MenuItems>
            {ITAH_ADMIN_LISTS.map((element) => (
              <Link to={element.route} key={uuid()}>
                <HeaderList>
                  <ListImage src={element.main_image} />
                  <HeaderTitleLists> {element.name} </HeaderTitleLists>
                </HeaderList>
              </Link>
            ))}
            <AdminInfo isMobile>
              <UserPicture src={Images.userDefaultImage} />
              <NameAndEmail>
                <UserName>Name Surname</UserName>
                <UserEmail>name@gmail.com</UserEmail>
              </NameAndEmail>

              <RightVector
                src={Images.selectDownArrowSilverIcon}
                onClick={toggleLaptopModal}
              />
            </AdminInfo>

            {isLaptopModal ? (
              <SampleModalWrapper>
                <ProfileOpeningModal />
              </SampleModalWrapper>
            ) : null}
          </MenuItems>
        </ListWrapper>
      </HeaderWrapper>
      <AdminInfo>
        <UserPicture src={Images.userDefaultImage} />
        <NameAndEmail>
          <UserName>Name Surname</UserName>
          <UserEmail>name@gmail.com</UserEmail>
        </NameAndEmail>

        {isOpen ? (
          <SampleModalWrapper ref={ref}>
            <ProfileOpeningModal />
          </SampleModalWrapper>
        ) : null}

        <RightVector src={Images.rightVector} onClick={toggleModal} />
      </AdminInfo>
    </LeftSideHeader>
  );
};
